/**
 * Búsqueda Oleum — carga diferida de predictive-search + IA al abrir el modal.
 */
(function () {
  'use strict';

  var loaded = false;
  var loading = null;

  function isSearchOpenTrigger(el) {
    if (!el || !el.getAttribute) return false;
    var attr = el.getAttribute('on:click') || '';
    return attr.indexOf('#search-modal/showDialog') !== -1;
  }

  function findSearchOpenTrigger(event) {
    var target = event.target;
    if (!(target instanceof Element)) return null;
    if (isSearchOpenTrigger(target)) return target;
    var el = target.closest('[on\\:click]');
    return el && isSearchOpenTrigger(el) ? el : null;
  }

  function loadStylesheet(href) {
    return new Promise(function (resolve, reject) {
      if (!href || document.querySelector('link[href="' + href + '"]')) {
        resolve();
        return;
      }
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src || document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadModule(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        resolve();
        return;
      }
      if (document.querySelector('script[type="module"][src="' + src + '"]')) {
        customElements.whenDefined('predictive-search-component').then(resolve).catch(resolve);
        return;
      }
      var script = document.createElement('script');
      script.type = 'module';
      script.src = src;
      script.onload = function () {
        customElements.whenDefined('predictive-search-component').then(resolve).catch(resolve);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function ensureSearchLoaded() {
    if (loaded) return Promise.resolve();
    if (loading) return loading;

    var assets = window.OleumSearchAssets || {};
    loading = Promise.resolve()
      .then(function () {
        if (assets.predictiveCss) return loadStylesheet(assets.predictiveCss);
      })
      .then(function () {
        if (assets.modalCss) return loadStylesheet(assets.modalCss);
      })
      .then(function () {
        if (assets.css) return loadStylesheet(assets.css);
      })
      .then(function () {
        if (assets.aiCss) return loadStylesheet(assets.aiCss);
      })
      .then(function () {
        return loadModule(assets.predictiveSearch);
      })
      .then(function () {
        if (assets.semanticSearch) return loadScript(assets.semanticSearch);
      })
      .then(function () {
        if (assets.aiSearch) return loadScript(assets.aiSearch);
      })
      .then(function () {
        return customElements.whenDefined('dialog-component');
      })
      .then(function () {
        loaded = true;
      })
      .catch(function (err) {
        loading = null;
        throw err;
      });

    return loading;
  }

  function openSearchModal() {
    var modal = document.getElementById('search-modal');
    if (!modal || typeof modal.showDialog !== 'function') return;

    modal.showDialog();

    window.requestAnimationFrame(function () {
      var input = modal.querySelector('.search-input');
      if (input) input.focus();
    });
  }

  function handleSearchOpen(event) {
    var trigger = findSearchOpenTrigger(event);
    if (!trigger || !isSearchOpenTrigger(trigger)) return;
    if (loaded) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    ensureSearchLoaded()
      .then(openSearchModal)
      .catch(function (err) {
        console.warn('[Oleum] Búsqueda no disponible:', err);
        openSearchModal();
      });
  }

  document.addEventListener('click', handleSearchOpen, true);

  // Carga IA/semántica también en discovery y /search (formularios con data-oleum-ai-endpoint)
  function preloadAiIfNeeded() {
    if (!document.querySelector('[data-oleum-ai-endpoint]')) return;
    var assets = window.OleumSearchAssets || {};
    if (!assets.aiSearch && !assets.semanticSearch) return;
    ensureSearchLoaded().catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preloadAiIfNeeded);
  } else {
    preloadAiIfNeeded();
  }

  window.OleumEnsureSearch = ensureSearchLoaded;
})();
